import React from 'react';
import {MessageSnackBar} from '@igp/shared/components/message';
import {SnackbarStack} from '@igp/shared/components/snackbar';
import {useReduxMessage} from '@igp/shared/redux/message';
import {RealtimeNotification} from '@igp/shared/redux/realtime';

export function Notifications() {
    const {message, messageValues, mode, clearMessages} = useReduxMessage();
    return (
        <SnackbarStack>
            <MessageSnackBar message={message} messageValues={messageValues} mode={mode} onClose={clearMessages} />
            <RealtimeNotification />
        </SnackbarStack>
    );
}
